import { render, staticRenderFns } from "./indexH5.vue?vue&type=template&id=73b1b716&"
import script from "./indexH5.vue?vue&type=script&lang=js&"
export * from "./indexH5.vue?vue&type=script&lang=js&"
import style0 from "./indexH5.vue?vue&type=style&index=0&id=73b1b716&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports